export default __webpack_public_path__ + "static/media/photo--lg--51.2ef18f42.jpg";